import { configureStore } from '@reduxjs/toolkit';
import { userReducer, UserState } from './user.slice';
import { loadingReducer, LoadingState } from './loading.slice';
import { merchantReducer, MerchantState } from './merchant.slice';
// import { navigationReducer, NavigationState } from './navigation.slice';

export interface AppStore {
  user: UserState;
  loading: LoadingState;
  merchant: MerchantState;
}



export const store = configureStore({
  reducer: {
    user: userReducer,
    loading: loadingReducer,
    merchant: merchantReducer,
    // navigation: navigationReducer,
  },

});

